/**
 * Case-insensitive multi-token match: every whitespace-separated token in
 * `query` must appear in at least one of the provided field values.
 */
export const matchesMultiTokenTextSearch = (
  query: string,
  fields: Array<string | null | undefined>,
): boolean => {
  const normalizedQuery = query.trim().toLowerCase().replace(/\s+/g, ' ');
  if (!normalizedQuery) return true;

  const tokens = normalizedQuery.split(' ');
  const haystacks = fields
    .filter((value): value is string => typeof value === 'string' && value.trim().length > 0)
    .map((value) => value.toLowerCase());

  if (haystacks.length === 0) return false;

  return tokens.every((token) => haystacks.some((haystack) => haystack.includes(token)));
};
